module.exports = __webpack_public_path__ + "media/images/city/039-national-congress-of-brazil-1aad63c49929faddb4950447cbb2ac54.svg";